import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import {useFetching} from "../../hooks/useFetching";
import {API_ABOUT_PRODUCTS_AND_SERVICES} from "../../utils/consts";
import parse from "html-react-parser";
import Footer from "../Footer";
import ApiAboutProductsAndServices from "../../services/About/ProductsAndServices";
import {observer} from "mobx-react-lite";

// import image_1 from '../../img/about/img1.png'
// import image_2 from '../../img/about/img.jpg'

const ProductsAndServices = () => {
    const location = useLocation();

    const [data, setData] = useState();
    // const [data, setData] = useState({name: 'Продукти та послуги', image_1: image_1, content_1: '<p>Ми пропонуємо повний виробничий цикл <a href="https://champion.tm/cabinets/">виготовлення ігрового та допоміжного обладнання</a>. Champion™ охоплює всі етапи виготовлення продукту, від концепції та розробки до обслуговування та підтримки. Ми використовуємо найсучасніші кросплатформенні технології розробки софту та враховуємо останні тенденції ринку ігрової індустрії.&nbsp;</p>', image_2: image_2, content_2: '<p>Ще один важливий сегмент послуг Champion™ - <a href="https://www.championstudio.net/ru/?lang=ru">дизайн та розробка онлайн ігор в казино та слотів</a>. Наше портфоліо налічує не лише традиційні ігри старої школи, а й ігри, що враховують потреби та уподобання сучасних гравців. Завдяки відповідальному ставленню до задач, ми створюємо продукт, що відповідає різним культурним особливостям та менталітету певного регіону.</p>\n' + '<p><br>Апаратні та програмні комплексні рішення для азартного бізнесу від Champion™ дозволяють нашим клієнтам залишатись конкурентоспроможними на сучасному ринку. Ми прагнемо створювати лише інноваційні продукти та підтримувати амбіції наших клієнтів.</p>'});

    const [FunctionApiAboutProductsAndServices] = useFetching(async () => {
        try {
            const response = await ApiAboutProductsAndServices.getApiAboutProductsAndServices(API_ABOUT_PRODUCTS_AND_SERVICES);
            setData(response.data);
        } catch {
            console.error('FunctionApiAboutProductsAndServices')
        }
    });

    useEffect(() => {
        FunctionApiAboutProductsAndServices();
    }, [location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            {data ? <div className="details_content content">
                <div className="up_catalog">
                    <div className="title_block">
                        {data.name && <h1>{data.name}</h1>}
                    </div>
                </div>
                <div className="new_games">
                    <div className="row">
                        <div className="up_catalog">
                            {data.image_1 ? <div className="title_block one">
                                <div className="img">
                                    <img src={data.image_1} alt="img" />
                                </div>
                            </div> : null }
                            {data.content_1 ? <div className="title_block">
                                {parse(data.content_1)}
                            </div> : null}
                            {data.image_2 ? <div className="title_block">
                                <div className="img">
                                    <img src={data.image_2} alt="img" />
                                </div>
                            </div> : null}
                            {data.content_2 ? <div className="title_block">
                                {parse(data.content_2)}
                            </div> : null}
                        </div>
                    </div>
                </div>
                <Footer />
            </div> : null}
        </>
    );
};

export default observer(ProductsAndServices);